function persistPartnerPrivacy(privacy) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem('partnerPrivacy', JSON.stringify(privacy));
  } catch (e) {
    // ignore storage errors
  }
}

function removePartnerPrivacy() {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem('partnerPrivacy');
  } catch (e) {
    // ignore storage errors
  }
}

function normalizePrivacy(privacy) {
  return {
    mostrar_email: Number(privacy?.mostrar_email) ? 1 : 0,
    mostrar_rfc: Number(privacy?.mostrar_rfc) ? 1 : 0,
  };
}

function extractPartnerPrivacy(partner, fallback) {
  const base = normalizePrivacy(fallback || { mostrar_email: 1, mostrar_rfc: 1 });

  if (!partner || typeof partner !== 'object') return base;

  if (Object.prototype.hasOwnProperty.call(partner, 'mostrar_email')) {
    base.mostrar_email = Number(partner.mostrar_email) ? 1 : 0;
  }

  if (Object.prototype.hasOwnProperty.call(partner, 'mostrar_rfc')) {
    base.mostrar_rfc = Number(partner.mostrar_rfc) ? 1 : 0;
  }

  return base;
}

const mutations = {
  SET_DATA(state, { key, data }) {
    state[key] = data;

    if (key === 'partner') {
      const privacy = extractPartnerPrivacy(data, state.partnerPrivacy);
      state.partnerPrivacy = privacy;
      persistPartnerPrivacy(privacy);
    }

    if (key === 'partnerPrivacy') {
      const privacy = normalizePrivacy(data);
      state.partnerPrivacy = privacy;
      persistPartnerPrivacy(privacy);
    }

    if (key === 'partnerToken' || key === 'partnerTokenTime') {
      if (!state.partnerToken || !state.partnerTokenTime) {
        removePartnerPrivacy();
      }
    }
  },
};

export default mutations;
